// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-components-virtual-table-index-container","row":"antd-pro-components-virtual-table-index-row","cell":"antd-pro-components-virtual-table-index-cell"};